export default "__VITE_ASSET__BizlbOQ0__"